<template>
  <div class="actions-wrapper">
    <div class="btn-wrapper" v-if="visible || (target === manifest.id)">
      <b-button id="open-documents-btn" variant="outline-secondary" class="actions-with-outline" @click="openDocuments" v-b-tooltip.hover title="Документы">
        <font-awesome-icon icon="paperclip"/>
      </b-button>
      <b-button id="open-documents-btn" variant="outline-secondary" class="actions-with-outline" @click="editPackage" v-b-tooltip.hover title="Редактировать">
        <font-awesome-icon icon="fa-solid fa-pencil"/>
      </b-button>
      <b-button v-if="status === 113" id="download-manifest" variant="outline-secondary" class="actions-with-outline" @click="downloadManifest" v-b-tooltip.hover title="Выгрузить Манифест">
        <font-awesome-icon v-if="target !== manifest.id" icon="download"/>
        <b-spinner v-else type="grow" label="Spinning" style="position: relative; top: -8px; left: -14px;" v-b-tooltip.hover title="Идёт загрузка"></b-spinner>
      </b-button>
    </div>
    <b-button variant="outline-secondary" :id="target" class="actions-without-outline">
      <font-awesome-icon icon="ellipsis-h"/>
    </b-button>
    <b-popover placement="left" :target="target" triggers="hover">
      <b-list-group>
        <b-list-group-item
          id="open-documents-item"
          class="border-top-0 border-left-0 border-right-0 border-bottom-0"
          @click="openDocuments">
          <font-awesome-icon icon="paperclip" class="action-popover-item"/><span class="ml-2">Документы</span>
        </b-list-group-item>
        <b-list-group-item
          id="edit-package-item"
          class="border-top-0 border-left-0 border-right-0 border-bottom-0"
          @click="editPackage">
          <font-awesome-icon icon="fa-solid fa-pencil" class="action-popover-item"/><span class="ml-2">Редактировать</span>
        </b-list-group-item>
        <b-list-group-item
          id="edit-package-as-new-item"
          class="border-top-0 border-left-0 border-right-0 border-bottom-0"
          @click="editPackageAsNew">
          <font-awesome-icon icon="fa-solid fa-file-pen" class="action-popover-item"/><span class="ml-2">Редактировать&nbsp;как&nbsp;новый</span>
        </b-list-group-item>
        <b-list-group-item
          v-if="status === 113"
          id="download-manifest"
          class="border-bottom-0 border-left-0 border-right-0"
          @click="downloadManifest">
          <font-awesome-icon v-if="target !== manifest.id" icon="download" class="action-popover-item"/>
          <b-spinner small v-else type="grow" v-b-tooltip.hover title="Идёт загрузка" label="Spinning"></b-spinner>
          <span class="ml-2">Выгрузить Манифест</span>
        </b-list-group-item>
        <b-list-group-item
          v-if="isAbleToDownloadCommitmentStatement"
          id="downloadCommitmentStatement"
          class="border-top-0 border-left-0 border-right-0 border-bottom-0"
          @click="downloadCommitmentStatement($event)">
          <font-awesome-icon icon="download" class="action-popover-item"/><span class="ml-2">Сформировать ЗО</span>
        </b-list-group-item>
        <b-list-group-item
          v-if="isAbleToDownloadEmptyContRegTable"
          id="downloadEmptyContRegTable"
          class="border-top-0 border-left-0 border-right-0 border-bottom-0"
          @click="downloadEmptyContRegTable($event)">
          <font-awesome-icon icon="download" class="action-popover-item"/><span class="ml-2">Скачать табл. рег. ЗО</span>
        </b-list-group-item>
      </b-list-group>
    </b-popover>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: 'PackagesListActions',
    props: [
      'visible',
      'target',
      'status',
      'manifest'
    ],
    data () {
      return {
        showPopover: false,
        busy: false
      }
    },
    computed: {
      isAbleToCreateCommissionShipment () {
        const hasRights = this.userInfo.rights.user.filter(item => {
          return item === 'create_commissionshipment'
        })
        return (hasRights.length > 0)
      },
      isAbleToDownloadCommitmentStatement () {
        const hasRights = this.userInfo.rights.user.filter(item => {
          return item === 'report_pds_zo'
        })
        return (hasRights.length > 0)
      },
      isAbleToDownloadEmptyContRegTable () {
        const hasRights = this.userInfo.rights.user.filter(item => {
          return item === 'report_pds_registration_table_zo'
        })
        return (hasRights.length > 0)
      },
      ...mapState(
        {
          userInfo: state => state.authorization.userInfo
        }
      )
    },
    methods: {
      openDocuments () {
        this.$emit('open_documents')
      },
      downloadManifest () {
        this.$emit('download_manifest', this.target)
      },
      downloadCommitmentStatement (event) {
        this.$emit('loadCommitmentStatement', event)
      },
      downloadEmptyContRegTable (event) {
        this.$emit('loadEmptyContRegTable', event)
      },
      editPackage () {
        this.$emit('edit_package')
      },
      editPackageAsNew () {
        this.$emit('edit_package_as_new')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .actions-wrapper {
    display: flex;
    justify-content: flex-end;
    align-items: stretch;
    .btn-wrapper {
      height: 32px;
      display: flex;
      @media screen
      and (min-width: 320px)
      and (max-width: 1634px) {
        display: none;
      }
    }
    .actions-with-outline {
      border-radius: 50%;
      width: 32px;
      height: 32px;
      position: relative;
      margin-right: 0.75rem;
      border: 2px solid #CFD8DC;
      &:hover {
        color: #fff !important;
        cursor: pointer;
      }
      svg {
        width: 16px;
        height: 16px;
        text-align: center;
        margin-right: 8px;
        position: absolute;
        top: calc((100% - 16px) / 2);
        left: calc((100% - 16px) / 2);
      }
    }
    .actions-without-outline {
      width: 32px;
      height: 32px;
      position: relative;
      padding: 0.1rem 0.375rem;
      border-radius: 50%;
      margin-right: 0.75rem;
      border: none;
      &:hover {
        cursor: pointer;
        border: none;
        background-color: transparent;
        color: #78909C;
      }
      &:focus {
        cursor: pointer;
        border: none;
        outline: none;
        background-color: transparent;
        color: #78909C;
        box-shadow: none;
        -moz-box-shadow: none;
        -o-box-shadow: none;
        -webkit-box-shadow: none;
      }
      svg {
        position: absolute;
        top: calc((100% - 18px) / 2);
        left: calc((100% - 20px) / 2);
        font-size: 21px;
      }
    }
  }
</style>
